var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.thisStaffId != null
        ? _c(
            "div",
            {
              staticClass: "optional-row mt10",
              staticStyle: { "padding-left": "0" }
            },
            [
              _c("span", [
                _vm._v("当前员工：【" + _vm._s(_vm.thisStaffName) + "】")
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.bizTopicList, function(bizTopic) {
        return _c("div", { staticClass: "msg-subscr-msanage" }, [
          bizTopic.bizEventMsgList != null &&
          bizTopic.bizEventMsgList.length > 0
            ? _c("div", [
                _c("div", { staticClass: "message-tips" }, [
                  _c("div", { staticClass: "inline-block mr20" }, [
                    _c("span", { staticClass: "font-gray1" }, [
                      _vm._v("主题：")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "font-black font-bold" }, [
                      _vm._v(_vm._s(bizTopic.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-block mr20" }, [
                    _c("span", { staticClass: "font-gray1" }, [
                      _vm._v("与商品有关：")
                    ]),
                    _vm._v(" "),
                    bizTopic.goodsRelated
                      ? _c("span", { staticClass: "font-green" }, [
                          _vm._v("是")
                        ])
                      : _c("span", { staticClass: "font-red" }, [_vm._v("否")])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "inline-block mr20" }, [
                    _c("span", { staticClass: "font-gray1" }, [
                      _vm._v("与服务有关：")
                    ]),
                    _vm._v(" "),
                    bizTopic.servcRelated
                      ? _c("span", { staticClass: "font-green" }, [
                          _vm._v("是")
                        ])
                      : _c("span", { staticClass: "font-red" }, [_vm._v("否")])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "message-body" }, [
                  _c(
                    "ul",
                    { staticClass: "native-table" },
                    [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _vm._l(bizTopic.bizEventMsgList, function(bizEventMsg) {
                        return _c(
                          "li",
                          {
                            staticClass: "table-tr",
                            class:
                              bizEventMsg.vipLevel <= _vm.currentVipLevel
                                ? ""
                                : "vipCtrl"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "table-td",
                                staticStyle: { "text-align": "left" }
                              },
                              [_vm._v(_vm._s(bizEventMsg.name))]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "table-td",
                                staticStyle: { "text-align": "left" }
                              },
                              [_vm._v(_vm._s(bizEventMsg.renderContent))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "table-td" }, [
                              bizEventMsg.hrTransOrgFlag
                                ? _c("span", { staticClass: "font-green" }, [
                                    _vm._v("支持")
                                  ])
                                : _c("span", { staticClass: "font-red" }, [
                                    _vm._v("不支持")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "table-td" }, [
                              bizEventMsg.vtTransOrgFlag
                                ? _c("span", { staticClass: "font-green" }, [
                                    _vm._v("支持")
                                  ])
                                : _c("span", { staticClass: "font-red" }, [
                                    _vm._v("不支持")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "table-td" }, [
                              bizEventMsg.siteMsgFlag
                                ? _c("span", { staticClass: "font-green" }, [
                                    _vm._v("支持")
                                  ])
                                : _c("span", { staticClass: "font-red" }, [
                                    _vm._v("不支持")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "table-td" }, [
                              bizEventMsg.emailFlag
                                ? _c("span", { staticClass: "font-green" }, [
                                    _vm._v("支持")
                                  ])
                                : _c("span", { staticClass: "font-red" }, [
                                    _vm._v("不支持")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "table-td" }, [
                              bizEventMsg.wxFlag
                                ? _c("span", { staticClass: "font-green" }, [
                                    _vm._v("支持")
                                  ])
                                : _c("span", { staticClass: "font-red" }, [
                                    _vm._v("不支持")
                                  ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "table-td" }, [
                              _vm._v(_vm._s(_vm.vipLevel[bizEventMsg.vipLevel]))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "table-td" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "swb-btn swb-btn-link",
                                  on: {
                                    click: function($event) {
                                      _vm.checkBizEventMsgForVip(
                                        bizEventMsg.id,
                                        bizEventMsg.name,
                                        bizEventMsg.topicId
                                      )
                                    }
                                  }
                                },
                                [_vm._v("订阅")]
                              )
                            ])
                          ]
                        )
                      })
                    ],
                    2
                  )
                ])
              ])
            : _vm._e()
        ])
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "table-tr" }, [
      _c(
        "div",
        {
          staticClass: "table-th",
          staticStyle: { width: "150px", "text-align": "left" }
        },
        [_vm._v("消息名称")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-th", staticStyle: { "text-align": "left" } },
        [_vm._v("消息内容")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "table-th", staticStyle: { width: "100px" } }, [
        _vm._v("平级机构")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-th", staticStyle: { width: "100px" } }, [
        _vm._v("下级机构")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-th", staticStyle: { width: "100px" } }, [
        _vm._v("发送站内信")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-th", staticStyle: { width: "100px" } }, [
        _vm._v("发送邮件")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-th", staticStyle: { width: "100px" } }, [
        _vm._v("微信消息")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-th", staticStyle: { width: "100px" } }, [
        _vm._v("VIP级别(及以上)")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-th", staticStyle: { width: "80px" } }, [
        _vm._v("操作")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b598dffa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b598dffa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/bizMsg/SubscrManage.vue
// module id = 3129
// module chunks = 1